import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import {
  Field,
  Dropdown,
  Option,
} from '@fluentui/react-components';
import { getCurrencyOptions } from '@bingads-webui-campaign-react/conversion-utils';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { GoalPropType, findOptionbyKey } from '@bingads-webui-campaign-react/auto-goal-creation-wizard-utils';

import { getGoalDetailFormStyles } from '../styles/goal-details-setting-form-style';
import { autoGoalSchemaFieldName } from '../auto-goal-schema';
import { ValidatedInput, errorMessageMapping, handleValidationMessages } from '../control-components/validated-helper';

export const DefaultRevenueFormUnstyled = ({
  i18n,
  classes,
  draftGoal,
  onChange,
}) => {
  const currencyOptions = useMemo(() => getCurrencyOptions(i18n), [i18n]);
  const selectedOption = findOptionbyKey(currencyOptions, draftGoal.CurrencyCode);
  const customError = {
    ...errorMessageMapping,
    decimalLength: _TL_('The number with up to 2 decimal places.'),
  };

  return (
    <div className={classes.rowContainer}>
      <div>
        <ValidatedInput
          fieldProps={{
            className: 'goalValue-input',
            label: i18n.getString(_TL_('Default revenue value')),
          }}
          i18n={i18n}
          onChange={e => onChange('GoalValue', e.target.value)}
          validationProps={{
            field: autoGoalSchemaFieldName.GoalValue,
            errorProcessor: errors => handleValidationMessages(i18n, errors, customError),
          }}
        />
      </div>
      <div style={{ width: '100%' }}>
        <Field
          label={i18n.getString(_TL_('Currency'))}
        >
          <Dropdown
            className="currency-dropdown"
            dropdownWidth="auto"
            aria-label={i18n.getString(_TL_('Select revenue currency'))}
            onOptionSelect={(ev, data) => onChange('CurrencyCode', data.optionValue || '')}
            value={selectedOption && selectedOption.text}
            selectedOptions={selectedOption && [selectedOption.key]}
          >
            {currencyOptions.map(option =>
              <Option value={option.key} key={option.key}> {option.text}</Option>)
          }
          </Dropdown>
        </Field>
      </div>
    </div>
  );
};

DefaultRevenueFormUnstyled.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape(_.mapObject(
    getGoalDetailFormStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  draftGoal: PropTypes.shape(GoalPropType).isRequired,
  onChange: PropTypes.func.isRequired,
};
export const DefaultRevenueForm = withDefaultStyles(DefaultRevenueFormUnstyled, getGoalDetailFormStyles);
